export const AUDIENCE_OPTIONS: DropdownOption<LiteraryEventAudience>[] = [
  { label: '---', value: undefined },
  { label: 'literaryEvents.audiences.general', value: 'general' },
  { label: 'literaryEvents.audiences.families', value: 'families' },
  { label: 'literaryEvents.audiences.adults', value: 'adults' },
  { label: 'literaryEvents.audiences.youth', value: 'youth' },
  { label: 'literaryEvents.audiences.children', value: 'children' },
]
